import { toast } from "sonner";

// Endereço público oficial: usa REACT_APP_PUBLIC_APP_URL quando configurado,
// caso contrário o próprio domínio em que o app está servido (que é o endereço
// oficial de produção após o deploy). Nunca compartilha rotas internas/tokens.
export function getOfficialUrl() {
  const env = (process.env.REACT_APP_PUBLIC_APP_URL || "").trim();
  const base = env || (typeof window !== "undefined" ? window.location.origin : "");
  return base ? base.replace(/\/+$/, "") + "/" : "";
}

export async function shareMetron() {
  const url = getOfficialUrl();
  if (!url) {
    toast.error("Nenhum endereço oficial configurado. Contate o Administrador.");
    return;
  }
  const title = "MÉTRON";
  const text = "Conheça o MÉTRON — Plataforma Modular de Avaliação e Gestão de Competências.";
  const shareData = { title, text, url };

  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share(shareData);
      return;
    } catch (err) {
      if (err && err.name === "AbortError") return; // usuário cancelou
      // segue para fallback de cópia
    }
  }

  const full = `${text}\n\nAcesse: ${url}`;
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(full);
    } else {
      const ta = document.createElement("textarea");
      ta.value = full;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    toast.success("Link do MÉTRON copiado! Cole e compartilhe onde quiser.");
  } catch (e) {
    toast.error("Não foi possível copiar o link.");
  }
}
